<template>
  <article
    class="block-list-card"
    :class="{ 'block-list-card--has-link': cardData.link && cardData.link.url }"
  >
    <div
      class="block-list-card__image"
      :class="{ 'block-list-card__image--2-col': columnCount === 2 }"
      v-if="showImage(cardData.image)"
    >
      <picture>
        <source
          :srcset="cardData.image.square.small"
          media="(max-width: 767px)"
        />
        <b-img-lazy
          fluid
          blank-color="#dce4e7"
          :src="
            columnCount == 2
              ? cardData.image.landscape.medium
              : cardData.image.square.medium
          "
          class=""
          :alt="cardData.image.alt"
        />
      </picture>
    </div>
    <div class="block-list-card__content">
      <p v-if="cardData.category" class="block-list-card__category">
        {{ cardData.category }}
      </p>
      <p v-else-if="cardData.categories && cardData.categories.length !== 0" class="block-list-card__category">
        <span v-for="(cat, idx) in cardData.categories" :key="`cat-${idx}`">
          {{ cat }}<span v-if="idx !== cardData.categories.length - 1">, </span>
        </span>
      </p>
      <h3
          v-bind:class="['block-list-card__heading', cardData.subhead ? 'block-list-card__heading--has-subhead' : '' ]"
        v-if="cardData.title && cardData.link"
      >
        <a :href="cardData.link.url" :target="cardData.link.target" ref="noopener noreferrer">{{
          cardData.title
        }}</a>
      </h3>
      <h3
        v-bind:class="['block-list-card__heading', cardData.subhead ? 'block-list-card__heading--has-subhead' : '' ]"
        v-if="cardData.title && !cardData.link"
      >
        {{ cardData.title }}
      </h3>
      <div class="block-list-card__subhead" v-if="cardData.subhead">{{ cardData.subhead }}</div>
      <div
        :class="`block-list-card__description block-list-card__descp_limit_${ descLineLmit }`"
        v-if="cardData.description"
        v-html="cardData.description"
      ></div>
    </div>
  </article>
</template>

<script lang="js">
export default  {
  name: 'ahc-block-list-card',
  props: {
    cardData: {
      type: Object,
      required: true
    },
    columnCount: {
      type: Number,
      default: 4,
    },  
  },
  data() {
    return {
      descLineLmit: this.calculateDescrptionLimit(),
    }
  },
  methods: {
    showImage(image) {
      return typeof(image.square) !== 'undefined' && Object.keys(image.square).length > 0;
    },
    /* if layout calls for limited description length */
    calculateDescrptionLimit () {

      this.descLineLmit = 4;

      if( this.cardData.description.length ) {
        console.log(this.cardData.title.length + this.cardData.category.length);
        if( this.cardData.title.length + this.cardData.category.length > 55 ){
            this.descLineLmit = 2;
        }
        else if( (this.cardData.title.length + this.cardData.category.length) > 30 && (this.cardData.title.length + this.cardData.category.length) < 55 ){
          this.descLineLmit = 3;
        }
        if(this.cardData.category.length === 0) {
          this.descLineLmit += 1;
        }
      }

      return this.descLineLmit;
    },
  }
}
</script>
